"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var ModalContainer = function (_a) {
    var companyName = _a.companyName, handleInputChange = _a.handleInputChange, errorType = _a.errorType;
    var getIdentifierLabel = function () {
        return companyName
            ? (0, translation_1.getLocalization)('customer/reliable/partner/modal/new/identifier')
            : (0, translation_1.getLocalization)('customer/reliable/partner/modal/add/identifier');
    };
    return (React.createElement(sok_ui_1.Container, { className: "reliablePartner-settings-container" },
        !companyName && (React.createElement("div", { className: "helper-text" }, (0, translation_1.getLocalization)('customer/reliable/partner/modal/connected/helper/text'))),
        companyName && (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "connected-identifier" }, (0, translation_1.getLocalization)('customer/reliable/partner/modal/connected/identifier')),
            React.createElement("div", { className: "selected-customer-placeholder" }, companyName))),
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "new-identifier" }, getIdentifierLabel()),
            React.createElement("input", { id: "new-identifier", type: "text", onChange: handleInputChange })),
        errorType && (React.createElement("div", { className: "error-message" }, (0, translation_1.getLocalization)("error/".concat(errorType))))));
};
exports.ModalContainer = ModalContainer;
